import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TextInputModel } from 'projects/money-movement-ui/src/app/shared/components/controls/text-input-control/TextInputModel';
import { Constants } from 'projects/money-movement-ui/src/app/shared/utilities/Constants';
import { Subject } from 'rxjs';
import * as CustomValidators from '../../../../shared/utilities/FormValidators';
import { createControl } from '../../../utilities/formUtilities';
import { CheckTransactionDetailsForm } from '../../../models/form/TransactionFormGroup';

@Component({
  standalone: false,
  selector: 'mm-check-modified-payee',
  templateUrl: './check-modified-payee.component.html',
  styleUrls: ['./check-modified-payee.component.scss']
})
export class CheckModifiedPayeeComponent implements OnInit {
  @Input() parentForm!: FormGroup<CheckTransactionDetailsForm>;
  @Input() useConstructedPayee: boolean;
  @Input() defaultPayee: string[];
  isFirstPartyModified: boolean;
  controlNames = {
    name1: 'modifiedPayeeName1',
    name2: 'modifiedPayeeName2',
    name3: 'modifiedPayeeName3',
  };
  payeeName1Model: TextInputModel = {
    controlName: this.controlNames.name1,
    label: 'Modified payee name',
    hasGreyText: false,
    htmlMaxLength: 44,
  };
  payeeName2Model: TextInputModel = {
    ...this.payeeName1Model,
    controlName: this.controlNames.name2,
  }
  payeeName3Model: TextInputModel = {
    ...this.payeeName1Model,
    controlName: this.controlNames.name3,
  }

  destroy$: Subject<boolean> = new Subject();
  isJointAccount: boolean = false;
  showModPayeeTwo: boolean = false;
  showModPayeeThree: boolean = false;
  payeeNameError: string = Constants.payeeNameMissing;

  constructor() { }

  ngOnInit(): void {
    createControl(
      this.parentForm,
      this.controlNames.name1,
      this.defaultPayee[0],
      [
        Validators.required,
        CustomValidators.isEmptyString,
      ]
    );

    if (this.defaultPayee.length >= 2) {
      this.showModPayeeTwo = true;
      createControl(
        this.parentForm,
        this.controlNames.name2,
        this.defaultPayee[1],
        [
          Validators.required,
          CustomValidators.isEmptyString,
        ]
      );
    }
    if (this.defaultPayee.length === 3) {
      this.showModPayeeThree = true;
      createControl(
        this.parentForm,
        this.controlNames.name3,
        this.defaultPayee[2],
        [
          Validators.required,
          CustomValidators.isEmptyString,
        ]
      );
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();

    if (this.modifiedPayeeName1) this.parentForm.removeControl('modifiedPayeeName1');
    if (this.modifiedPayeeName2) this.parentForm.removeControl('modifiedPayeeName2');
    if (this.modifiedPayeeName3) this.parentForm.removeControl('modifiedPayeeName3');
  }

  get modifiedPayeeName1(): FormControl<string> {
    return this.parentForm.get('modifiedPayeeName1') as FormControl<string>;
  }

  get modifiedPayeeName2(): FormControl<string> {
    return this.parentForm.get('modifiedPayeeName2') as FormControl<string>;
  }

  get modifiedPayeeName3(): FormControl<string> {
    return this.parentForm.get('modifiedPayeeName3') as FormControl<string>;
  }
}
